import {
    PAGE_MODE_CHANGE
} from '..'

export default class PageMode {

    static change(value) {
        return (dispatch) => dispatch({
            type: PAGE_MODE_CHANGE,
            value
        })
    }

}



// WEBPACK FOOTER //
// src/actions/page-mode/index.js